import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './lib/auth/AuthContext'
import Layout from './components/Layout'
import AuthGuard from './components/AuthGuard'
import { Toaster } from './components/ui/toaster'

// Page imports
import MatchMetricsPage from './pages/MatchMetricsPage'
import Login from './pages/Login'
import EventOpsPage from './pages/EventOpsPage'
import InfrastructurePage from './pages/InfrastructurePage'
import QueuesPage from './pages/QueuesPage'
import SubscribersPage from './pages/SubscribersPage'
import SimulationsPage from './pages/SimulationsPage'
import CleanUserIdPage from './pages/CleanUserIdPage'
import EventsPage from './pages/EventsPage'
import ClubroomGifsPage from './pages/ClubroomGifsPage'

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <Layout>
                <AuthGuard>
                  <Routes>
                    <Route path="/" element={<EventsPage />} />
                    <Route path="/event-operations" element={<EventOpsPage />} />
                    <Route path="/infra" element={<InfrastructurePage />} />
                    <Route path="/queues" element={<QueuesPage />} />
                    <Route path="/subscribers" element={<SubscribersPage />} />
                    <Route path="/match-metrics" element={<MatchMetricsPage />} />
                    <Route path="/simulations" element={<SimulationsPage />} />
                    <Route path="/cleanUserId" element={<CleanUserIdPage />} />
                    <Route path="/clubroom-gifs" element={<ClubroomGifsPage />} />
                  </Routes>
                </AuthGuard>
              </Layout>
            }
          />
        </Routes>
        <Toaster />
      </AuthProvider>
    </Router>
  )
}

export default App
